import { Controller } from "@hotwired/stimulus"
import SignaturePad from "signature_pad"

export default class extends Controller {
  static targets = ["canvas", "input"]

  connect() {
    const canvas = this.canvasTarget
    const input = this.inputTarget

    if (canvas) {
      canvas.height = canvas.offsetHeight
      canvas.width = canvas.offsetWidth
      canvas.style.touchAction = "none"
      this.signaturePad = new SignaturePad(canvas, {
        penColor: "rgb(66, 133, 244)",
      })
      this._forceIOSTouchEvents()

      this.signaturePad.addEventListener("endStroke", () => {
        input.value = this.signaturePad.toDataURL()
      })
    }
  }

  disconnect() {
    this.signaturePad.off()
  }

  _forceIOSTouchEvents() {
    const isIOS =
      /iPhone|iPad|iPod/.test(navigator.userAgent) ||
      (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1)
    if (isIOS && window.PointerEvent) {
      this.signaturePad.off()
      const origPointerEvent = window.PointerEvent
      window.PointerEvent = undefined
      this.signaturePad.on()
      window.PointerEvent = origPointerEvent
    }
  }
}
